import React from 'react';
import isString from 'lodash/isString';
import isArray from 'lodash/isArray';
import isFinite from 'lodash/isFinite';
import getKey from 'lodash/get';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Link } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  stringify as stringifyQuery,
  parse as parseQuery,
  // eslint-disable-next-line import/no-extraneous-dependencies
} from 'query-string';

import moment from 'moment-timezone';

import Popover from 'antd/lib/popover';

import { renderCurrency } from './SystemCountry';

import Types from '../modules/types';

const {
  CONSTANTS: {
    OrderStatus,
    ShippingStorage,
    ShippingProvider,
  },
} = Types;

const MS_DAY = 24 * 60 * 60 * 1000;

export function lowerCaseRestLetters(word) {
  return `${word[0].toUpperCase()}${word.slice(1).toLowerCase()}`;
}

export function getScheduledOrderDue(subject) {
  const { timezone } = Types.getSystemCountry(subject.systemCountry);
  const now = moment().tz(timezone);
  const scheduledFor = moment(
    subject.shipping.scheduledFor,
  );
  const deltaDays = (
    scheduledFor.diff(now, 'milliseconds') / MS_DAY
  );
  // console.log('delta days:', deltaDays);
  // console.log('delta hours:', deltaDays * 24);
  if (deltaDays <= 0) {
    // if (deltaDays >= -0.3) {
    //   return 'this morning';
    // }
    if (deltaDays >= -1) {
      return 'today';
    }
  } else if (deltaDays > 0) {
    // if (deltaDays < 0.3) {
    //   return 'next morning';
    // }
    if (deltaDays <= 1) {
      return 'tomorrow';
    }
  }
  return scheduledFor.from(now);
}

export function formatOrderStatus(subject, viewer) {
  if (isString(subject)) {
    return Types.ORDER_STATUS_LABELS_MAP[subject];
  }
  if (subject && subject.status) {
    if (
      viewer
      && subject
      && viewer.role === 'SELLER'
      && subject.status === OrderStatus.APPROVAL
      && subject?.shipping?.storage === ShippingStorage.WAREHOUSE
    ) {
      return 'Processing';
    }
    return (
      <span>
        <span>
          {Types.ORDER_STATUS_LABELS_MAP[subject.status]}
        </span>
        {
          subject.status === 'DRAFT' && subject.draftPurpose === 'POS'
          ? <span style={{ opacity: 0.5 }}>{' / (POS)'}</span>
          : null
        }
        {
          subject.status === 'NEW'
          ? (
              <span style={{ opacity: 0.5 }}>
                {
                    subject.shipping?.scheduled
                  ? ` / Scheduled: Due ${getScheduledOrderDue(subject)}`
                  : !subject.shipping?.readyForPickup
                  ? (
                      ' / Preparing'
                      // subject.shipping.scheduledFor
                      // ? ` / Preparing (Scheduled: Due ${
                      //       getScheduledOrderDue(subject)
                      //     })`
                      // : ' / Preparing'
                    )
                  : ` / Ready${
                      (
                        (
                          (
                            viewer?.role === 'ADMIN'
                            // eslint-disable-next-line max-len
                            && subject.shipping?.provider === ShippingProvider.PACKMAN_SHOP
                          )
                        || (
                            Types.SHIPPING_PROVIDER_STORE.includes(
                              subject.shipping?.provider
                            )
                          )
                        )
                        && subject.shipping?.companyExported
                      )
                      ? ' (Exported)'
                      : ''
                    }`
                }
              </span>
            )
          : null
        }
      </span>
    );
  }
  return undefined;
}

export function formatIndexAmount(amount) {
  return `${
    (
      isFinite(amount)
      ? amount.toFixed(0)
      : `${amount}`
    ).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }`;
}

export function renderOrderAmount(subject, valuePath) {
  const output = (
    // eslint-disable-next-line react/jsx-key
    <span style={{ whiteSpace: 'nowrap' }}>
      {renderCurrency({
        prefix: `${
          Types.decimalize(getKey(subject, valuePath, 0))
        } `,
      })}
    </span>
  );
  return (
    <div style={{ textAlign: 'right' }}>
      {output}
    </div>
  );
}

export function getLinkWithSearchFields(
  location,
  fields = [],
  extras = {},
) {
  const search = parseQuery(
    location
    ? location.search.slice(1)
    : ''
  );
  fields.forEach(({ name, value, replace = false }) => {
    if (replace) {
      search[name] = value;
    } else {
      search[name] = (
        !search[name]
        ? []
        : isArray(search[name])
        ? search[name]
        : [search[name]]
      )
      .filter(testValue => (
        isArray(value)
        ? !value.includes(testValue)
        : value !== testValue
      ));
      search[name].push(...isArray(value) ? value : [value]);
    }
  });
  return { ...location, ...extras, search: `?${stringifyQuery(search)}` };
}

export function getSubjectUrl(pathname, subject) {
  return `${pathname}/${subject._id || subject}`;
}

export function StoreLink({
  location,
  subject,
  filterName = 'store',
  searchLabel = 'store',
  children,
  style,
}) {
  if (!subject) {
    return 'N / A';
  }
  return (
    <Popover
      title={null}
      content={(
        <div>
          <span>Show orders with </span>
          <Link
            to={getLinkWithSearchFields(
              location,
              [{ name: filterName, value: subject._id }],
              { pathname: '/orders' },
            )}
          >
            {`this ${searchLabel}`}
          </Link>
        </div>
      )}
    >
      <Link style={style} to={getSubjectUrl('/stores', subject)}>
        {
          children
          ? children
          : `${subject.name}`
        }
      </Link>
    </Popover>
  );
}

export function DateLink({
  location,
  date,
  children,
  pathname = '/orders',
}) {
  date = moment(date);
  return (
    <Popover
      title={null}
      content={(
        <div>
          Show orders this:
          <span> </span>
          {
            ['day', 'week', 'month'].reduce(
              (agr, range, i, array) => {
                agr.push(
                  <Link
                    key={range}
                    to={getLinkWithSearchFields(
                      location,
                      [
                        {
                          name: 'from',
                          value: date.startOf(range).toJSON(),
                          replace: true,
                        },
                        {
                          name: 'to',
                          value: date.endOf(range).toJSON(),
                          replace: true,
                        },
                      ],
                      { pathname },
                    )}
                  >
                    {range}
                  </Link>
                );
                if (i < array.length - 1) {
                  agr.push(<span key={`${range}-separator`}> / </span>);
                }
                return agr;
              },
              [],
            )
          }
        </div>
      )}
    >
      {
        children
        ? children
        : date.fromNow()
      }
    </Popover>
  );
}

export function EmailLink({
  email,
  subject,
  orderId,
}) {
  return (
    <a
      href={`mailto:${email}${
        subject
        ? `?subject=${subject}`
        : orderId
        ? `?subject=${`Order #${orderId}`}`
        : ''
      }`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {email}
    </a>
  );
}

export function PhoneNumberLink({
  phoneNumberString,
}) {
  return (
    <a
      href={`tel:${phoneNumberString}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {phoneNumberString}
    </a>
  );
}

export function ProductCategoryLink({
  location,
  subject,
  valuePath = 'category',
  pathname = '/products',
  children,
}) {
  const value = getKey(subject, valuePath);
  return (
    <Popover
      title={null}
      content={(
        <div>
          <span>Show products with </span>
          <Link
            to={getLinkWithSearchFields(
              location,
              [{
                name: 'category',
                value: value && value._id
                ? value._id
                : value,
              }],
              { pathname },
            )}
          >
            this category
          </Link>
        </div>
      )}
    >
      {children}
    </Popover>
  );
}

export function ProductCollectionLink({
  location,
  subject,
  valuePath = 'collection',
  pathname = '/products',
  children,
}) {
  const value = getKey(subject, valuePath);
  return (
    <Popover
      title={null}
      content={(
        <div>
          <span>Show products with </span>
          <Link
            to={getLinkWithSearchFields(
              location,
              [{
                name: 'collection',
                value: value && value._id
                ? value._id
                : value,
              }],
              { pathname },
            )}
          >
            this collection
          </Link>
        </div>
      )}
    >
      {children}
    </Popover>
  );
}

export function OrderStatusLink({
  location,
  subject,
  viewer,
  pathname = '/orders',
  children,
}) {
  return (
    <Popover
      title={null}
      content={(
        <div>
          <span>Show orders with </span>
          <Link
            to={getLinkWithSearchFields(
              location,
              [{
                name: 'status',
                value: (
                  subject.status === 'NEW'
                  ? (
                        subject.shipping && subject.shipping.scheduled
                      ? 'NEW-SCHEDULED'
                      : subject.shipping && !subject.shipping.readyForPickup
                      ? 'NEW-PREPARING'
                      : 'NEW-READY'
                    )
                  : subject.status
                ),
              }],
              { pathname },
            )}
          >
            this status
          </Link>
        </div>
      )}
    >
      {
        children
        ? children
        : (
            <span>
              {formatOrderStatus(subject, viewer)}
              {/* {
                subject
                && subject.payment
                && (() => {
                  if (subject.payment.refunded) {
                    return ' (Refunded)';
                  } if (subject.payment.captured) {
                    return ' (Captured)';
                  } if (subject.payment.authorized) {
                    return ' (Authorized)';
                  } if (subject.payment.voided) {
                    return ' (Voided)';
                  }
                  return '';
                })()
              } */}
            </span>
          )
      }
    </Popover>
  );
}

export function AmountLink({
  location,
  subject,
  noun = 'orders',
  pathname = '/orders',
  valuePath = 'amount',
}) {
  return (
    <Popover
      title={null}
      content={(
        <div>
          <span>{`Show ${noun} `}</span>
          <Link
            to={getLinkWithSearchFields(
              location,
              [{
                name: 'above',
                value: getKey(subject, valuePath),
                replace: true,
              }],
              { pathname },
            )}
          >
            above
          </Link>
          <span> / </span>
          <Link
            to={getLinkWithSearchFields(
              location,
              [{
                name: 'under',
                value: getKey(subject, valuePath),
                replace: true,
              }],
              { pathname },
            )}
          >
            under
          </Link>
          <span> this amount</span>
        </div>
      )}
    >
      {renderOrderAmount(subject, valuePath)}
    </Popover>
  );
}

// export function StoreLink({
//   // location,
//   subject,
//   children,
//   ...props
// }) {
//   if (!subject) {
//     return 'N / A';
//   }
//   return (
//     <Link to={getSubjectUrl('/users', subject)} {...props}>
//       {
//         children
//         ? children
//         : `${subject.name}`
//       }
//     </Link>
//   );
// }

export function ReviewLink({
  location,
  subject,
  valuePath = 'product',
  valueName,
  pathname = '/reviews',
  children,
}) {
  valueName = valueName || valuePath;
  const value = getKey(subject, valuePath);
  return (
    <Popover
      title={null}
      content={(
        <div>
          <span>Show reviews for </span>
          <Link
            to={getLinkWithSearchFields(
              location,
              [{
                name: valueName,
                value: value && value._id
                  ? value._id
                  : value,
              }],
              { pathname },
            )}
          >
            this
            {' '}
            {valueName}
          </Link>
        </div>
      )}
    >
      {children}
    </Popover>
  );
}
